function HULU_LOGO({ height, width, ...rest }) {
  return (
    <img
      src="/media/as-seen-in/hulu-logo.png"
      style={{ height, width }}
      {...rest}
    ></img>
  );
}

export default HULU_LOGO;
